module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAMAAAAfZPc8AAAAAXNSR0IB2cksfwAAADZQTFRFAAAAwsLGw8XHxMbIv7/KxMTEv8LGxMTHv7+/v8bGwcTGw8PHwsXHv7+/v8XFwsTHwsXIv8fHDpsJ/AAAABJ0Uk5TAFCAeBg4UGgQKHhAYAgwaFggdu+EOQAAAH1JREFUeJxtz1sSwyAIBdAbJCXRInX/m219djTyyWHgAhy0KcfAsSPHfIJeT5Lr9gFEb40L5EYWspkKVJnpoycNIePkGvRETcgzuwmGiGqhgL64ye+oTywU1frNKjVN1FttxCkibSxm6JRF1k+tffqASgEbKPRPuZICaVsXvvlNCKSik0oGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/message-icon.png
// module id = 286
// module chunks = 33